import { MAWBSubscriptionFormErrorJSON } from '../models/mawb-subscription-form';

export const MAWBSubscriptionFormErrors: MAWBSubscriptionFormErrorJSON = {
    email: [
        {
            code: 'regex',
            message: 'Invalid email',
        },
        {
            code: 'required',
            message: 'Required field',
        },
    ],
};
